import React from 'react'
import { Partners } from '@shared/lib/partner'
import HomeIcon from '../assets/HomeIcon'
import SteamIcon from '../assets/SteamIcon'
import GamesIcon from '../assets/GamesIcon'
import KeysIcon from '../assets/KeysIcon'
import ServicesIcon from '../assets/ServicesIcon'
import NewsIcon from '../assets/NewsIcon'
import MoreIcon from '../assets/MoreIcon'
import NeuralNetworksIcon from '../assets/NeuralNetworksIcon'
import DesignIcon from '../assets/DesignIcon'
import TripInternetIcon from '../assets/TripInternetIcon'

export const mainNavbarItem = {
  label: 'Главная',
  href: '/',
  icon: <HomeIcon />,
}

export const steamNavbarItem = {
  label: 'Steam',
  href: '/steam',
  icon: <SteamIcon />,
}

export const gamesNavbarItem = {
  label: 'Донаты',
  href: '/games',
  icon: <GamesIcon />,
}

export const keysNavbarItem = {
  label: 'Ключи',
  href: '/keys',
  icon: <KeysIcon />,
}

export const servicesNavbarItem = {
  label: 'Сервисы',
  href: '/services',
  icon: <ServicesIcon />,
}

export const newsNavbarItem = {
  label: 'Новости',
  href: '/news',
  icon: <NewsIcon />,
}

export const moreNavbarItem = {
  label: 'Ещё',
  icon: <MoreIcon />,
}

const neuralNetworksNavbarItem = {
  label: 'Нейросети',
  href: 'https://payment.mts.ru/tools',
  icon: <NeuralNetworksIcon />,
}

const designNavbarItem = {
  label: 'Для дизайна',
  href: 'https://payment.mts.ru/tools',
  icon: <DesignIcon />,
}

const tripInternetNavbarItem = {
  label: 'Интернет в поездках',
  href: 'https://payment.mts.ru/esim',
  icon: <TripInternetIcon />,
}

export const getDesktopNavbarItemsByPartner = (partner: Partners) => {
  switch (partner) {
    case Partners.DEFAULT:
      return [mainNavbarItem, steamNavbarItem, gamesNavbarItem, keysNavbarItem, servicesNavbarItem, newsNavbarItem]
    default:
      return [mainNavbarItem, steamNavbarItem, gamesNavbarItem, keysNavbarItem, servicesNavbarItem]
  }
}

export const getMobileNavbarItemsByPartner = (partner: Partners) => {
  switch (partner) {
    case Partners.DEFAULT:
      return [mainNavbarItem, gamesNavbarItem, steamNavbarItem, servicesNavbarItem, moreNavbarItem]
    default:
      return [mainNavbarItem, gamesNavbarItem, steamNavbarItem, servicesNavbarItem, moreNavbarItem]
  }
}

export const getMobileMoreModalNavbarItemsByPartner = (partner: Partners) => {
  switch (partner) {
    case Partners.DEFAULT:
      return [keysNavbarItem, newsNavbarItem, neuralNetworksNavbarItem, designNavbarItem, tripInternetNavbarItem]
    default:
      return [keysNavbarItem]
  }
}
